import { useEffect, useState } from "react";

const navLinks = [
  { href: "#trend", label: "实时热搜" },
  { href: "#overview", label: "风评总览" },
  { href: "#focus", label: "争议焦点" },
  { href: "#comments", label: "评论区热评" },
  { href: "#timeline", label: "风评时间线" },
  { href: "#faq", label: "常见问题" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="哇偶围观站 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg" aria-hidden="true" />
          </span>
          <span className="leading-none">
            <span className="font-heading block text-lg font-bold text-foreground-950">哇偶围观站</span>
            <span className="font-bebas block text-[11px] tracking-widest text-foreground-600">WAOU ROUNDUP</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#subscribe"
            className="ml-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅热搜快报
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-900 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={open ? "ri-close-line" : "ri-menu-3-line"} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-2 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-[15px] text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅热搜快报
            </a>
          </div>
        </div>
      )}
    </header>
  );
}